<template>
  <div class="common-card supplier-documents-list-wrapper">
    <modal-supplier-document-filter
      :filter_expense_type.sync="filter_expense_type"
      :filter_approval_status.sync="filter_approval_status"
      :filter_supplier_id.sync="filter_supplier_id"
      :filter_date_from.sync="filter_date_from"
      :filter_date_to.sync="filter_date_to"

      :expenseTypeOptions="expenseTypeOptions"
      :approvalStatusOptions="approvalStatusOptions"
      :supplierOptions="supplierOptions"

      @refetch-data="refetchData"
    />

    <b-card class="top mb-0">
      <div class="d-flex flex-wrap align-items-center justify-content-between">
        <div class="d-flex mb-1 mb-sm-0 align-items-center">
          <h4 class="font-weight-bolder ml-1 text-nowrap mb-0">
            <feather-icon class="mr-50" icon="FileTextIcon" />
            供應商帳單列表
          </h4>
          <div class="d-flex ml-3 align-items-center">
            <label>顯示</label>
            <v-select
              v-model="perPage"
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              :options="perPageOptions"
              :clearable="false"
              class="per-page-selector d-inline-block mx-50"
            />
            <label>條目</label>
          </div>
        </div>
        <div class="d-flex flex-wrap mobile-w100 mt-1 mt-lg-0">
         
          <b-button
            variant="primary"
            class="mobile-w100 mr-sm-1 mb-1 mb-sm-0"
            @click="$bvModal.show('modal-supplier-document-filter')"
            ><feather-icon
              class="mr-1"
              icon="filterIcon"
              size="18"
            ></feather-icon
            >篩選</b-button
          >
          <!-- <span class="d-none d-lg-block mr-1"> 開支類型: </span>
          <v-select
            v-model="expenseTypeFilter"
            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
            :options="expenseTypeOptions"
            :reduce="(option) => option.value"
            label="label"
            :clearable="false"
            class="expense-type-selector d-inline-block mr-sm-1 mb-1 mb-sm-0 ml-1"
            placeholder="開支類型"
          />
          <span> 埋數狀態: </span>
          <v-select
            v-model="approvalStatusFilter"
            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
            :options="approvalStatusOptions"
            :reduce="(option) => option.value"
            label="label"
            :clearable="false"
            class="approval-status-selector d-inline-block mr-sm-1 mb-1 mb-sm-0 ml-1"
            placeholder="埋數狀態"
          /> -->
         <b-form-input
            v-model="searchQuery"
            class="search-form mb-1 mb-sm-0 mr-sm-1"
            placeholder="搜尋供應商帳單"
          />
          <b-button
            v-if="ability.can('upload_document', 'staff_supplier_documents')"
            variant="primary"
            class="d-flex py-50 px-3 align-items-center mb-1 mb-sm-0 mr-1"
            @click="handleModelDocument(false)"
          >
            <feather-icon icon="PlusIcon" size="20" />
            上傳帳單
          </b-button> 
           <!-- <b-button
            v-if="ability.can('upload_receipt_document', 'staff_supplier_documents')"
            variant="primary"
            class="d-flex py-50 px-3 align-items-center mb-1 mb-sm-0 mr-1"
            @click="handleModelReceiptDocument(false)"
          >
            <feather-icon icon="PlusIcon" size="20" />
            上傳收據
          </b-button> -->
           <!-- <b-button
            v-if="ability.can('upload_receipt_document', 'staff_supplier_documents')"
            variant="primary"
            class="d-flex py-50 px-3 align-items-center mb-1 mb-sm-0 mr-1"
            @click="handleModelreceiptDocument(false)"
          >
            <feather-icon icon="PlusIcon" size="20" />
            上傳付款憑證
          </b-button> -->
          <b-button
            v-if="ability.can('export', 'staff_supplier_documents')"
            variant="outline-secondary"
            class="d-flex py-50 px-3 align-items-center mb-1 mb-sm-0"
            @click="handleExport"
          >
            <feather-icon icon="DownloadIcon" size="20" />
            匯出 Excel
          </b-button>
        </div>
      </div>
    </b-card>

    <!-- 金額統計卡片 -->
    <div class="amount-stats-container mt-3">
      <b-card class="amount-stat-card text-center">
        <h5 class="text-primary mb-1">${{ totalAmount }}</h5>
        <small class="text-muted">總額</small>
      </b-card>
      <b-card class="amount-stat-card text-center">
        <h5 class="text-success mb-1">${{ approvedAmount }}</h5>
        <small class="text-muted">已埋數總額</small>
      </b-card>
      <b-card class="amount-stat-card text-center">
        <h5 class="text-warning mb-1">${{ pendingAmount }}</h5>
        <small class="text-muted">未埋數總額</small>
      </b-card>
    </div>

    <b-card no-body class="card-statistics bottom">
      <b-card-body class="p-2">
        <b-table
          ref="refSupplierDocumentListTable"
          class="position-relative"
          :items="fetchSupplierDocuments"
          responsive
          :fields="documentTableColumns"
          primary-key="id"
          :sort-by.sync="sortBy"
          show-empty
          empty-text="未找到匹配的記錄"
          :sort-desc.sync="isSortDirDesc"
        >
          <!-- 供應商欄位 -->
          <template #cell(supplier)="data">
            <div v-if="data.item.supplier">
              <strong>{{ data.item.supplier.name || data.item.supplier.name_cn || '未命名供應商' }}</strong>
              <br v-if="data.item.supplier.name_cn">
              <small v-if="data.item.supplier.name_cn" class="text-muted">{{ data.item.supplier.name_cn }}</small>
            </div>
            <div v-else>
              <span class="text-muted">未指定供應商</span>
            </div>
          </template>

          <!-- 帳單預覽 -->
          <template #cell(bill_preview)="data">
            <div class="text-center preview-column">

              <div class="previewWrapper">
              <template
                v-if="
                  data.item.image_url &&
                  data.item.image_url.indexOf('.pdf') > -1
                "
              >
                <embed
                  class="pdf"
                  style="max-width: 100px; max-height: 100px"
                  :src="data.item.image_url"
                  type="application/pdf"
                />
              </template>
              <template v-else-if="data.item.image_url">
                <img
                  style="max-width: 80px; max-height: 80px"
                  :src="data.item.image_url"
                  alt="帳單"
                  class="img-fluid"
                />
              </template>
              </div>
              <div v-if="data.item.image_url">
                <a
                  class="color1 text-sm"
                  @click="previewImageSet(supplierDocuments, data.index)"
                  >預覽</a
                >
                   <div>{{ data.item.bill_number }}</div>
              </div>
              <div v-else-if="ability.can('upload_document', 'staff_supplier_documents')" class="mt-1">
                <b-button
                  size="sm"
                  variant="outline-secondary"
                  class="upload-btn"
                  @click="handleModelDocument(data.item)"
                >
                  <feather-icon icon="UploadIcon" size="12" class="mr-1" />
                  未上傳
                </b-button>
              </div>
              <!-- 編輯帳單按鈕 -->
              <div class="mt-2">
                <b-button
                  v-if="ability.can('update_document', 'staff_supplier_documents')"
                  size="sm"
                  variant="outline-primary"
                  @click="handleModelDocument(data.item)"
                >
                  <feather-icon icon="EditIcon" size="14" />
                  編輯
                </b-button>
              </div>
              <!-- 刪除帳單按鈕 -->
              <div class="mt-2">
                <b-button
                  v-if="ability.can('delete_document_file', 'staff_supplier_documents')"
                  size="sm"
                  variant="outline-danger"
                  @click="deleteRecord(data.item.id, 'deleteSupplierBillFiles')"
                >
                  <feather-icon icon="TrashIcon" size="14" />
                  刪除帳單文件
                </b-button>
              </div>
            </div>
          </template>

          <!-- 付款憑證預覽 -->
          <template #cell(payment_proof_preview)="data">
            <div class="text-center preview-column">
              <template
                v-if="
                  hasPaymentProof(data.item)
                "
              >
              <div class="previewWrapper position-relative">
                <!-- 多筆付款憑證的堆疊顯示效果 -->
                <template v-if="data.item.payment_proofs && data.item.payment_proofs.length > 1">
                  <!-- 背景層（第二個檔案的陰影） -->
                  <!-- <div
                    class="payment-proof-shadow"
                    style="position: absolute; top: 3px; left: 3px; width: 80px; height: 80px; background: #e9ecef; border-radius: 4px; z-index: 1;"
                  ></div> -->
                  <!-- 前景層（第一個檔案） -->
                  <div style="position: relative; z-index: 2;">
                    <template v-if="getPaymentProofFileType(data.item) === 'pdf'">
                      <embed
                        class="pdf"
                        style="max-width: 80px; max-height: 80px; border: 2px solid #007bff; border-radius: 4px;"
                        :src="getPaymentProofImageUrl(data.item)"
                        type="application/pdf"
                      />
                    </template>
                    <template v-else>
                      <img
                        style="max-width: 80px; max-height: 80px; border: 2px solid #007bff; border-radius: 4px;"
                        :src="getPaymentProofImageUrl(data.item)"
                        alt="付款憑證"
                        class="img-fluid"
                      />
                    </template>
                  </div>
                  <!-- 數量標籤 -->
                  <!-- <b-badge
                    variant="primary"
                    class="position-absolute"
                    style="top: -5px; right: -5px; z-index: 3; font-size: 10px;"
                  >
                    {{ data.item.payment_proofs.length }}
                  </b-badge> -->
                </template>

                <!-- 單筆付款憑證的正常顯示 -->
                <template v-else>
                  <template v-if="getPaymentProofFileType(data.item) === 'pdf'">
                    <embed
                      class="pdf"
                      style="max-width: 80px; max-height: 80px; border-radius: 4px;"
                      :src="getPaymentProofImageUrl(data.item)"
                      type="application/pdf"
                    />
                  </template>
                  <template v-else>
                    <img
                      style="max-width: 80px; max-height: 80px; border-radius: 4px;"
                      :src="getPaymentProofImageUrl(data.item)"
                      alt="付款憑證"
                      class="img-fluid"
                    />
                  </template>
                </template>
              </div>
                <div>
                  <a
                    class="color1 text-sm"
                    @click="previewPaymentProof(data.item)"
                    >預覽</a
                  >
                   <div>{{ getPaymentProofNumber(data.item) }}</div>
                </div>
                <!-- 編輯付款憑證按鈕 -->
                <div class="mt-2">
                  <b-button
                    v-if="ability.can('edit_payment_proof', 'staff_supplier_documents')"
                    size="sm"
                    variant="outline-success"
                    @click="handleUploadPaymentProof(data.item)"
                  >
                    <feather-icon icon="EditIcon" size="14" />
                    編輯
                  </b-button>
                </div>
                <!-- 刪除付款憑證按鈕 -->
                <div class="mt-2">
                  <b-button
                    v-if="ability.can('delete_payment_proof', 'staff_supplier_documents')"
                    size="sm"
                    variant="outline-danger"
                    @click="deleteRecord(data.item.id, 'deleteSupplierPaymentProof')"
                  >
                    <feather-icon icon="TrashIcon" size="14" />
                    刪除付款憑證紀錄
                  </b-button>
                </div>
              </template>
              <template v-else-if="ability.can('upload_payment_proof', 'staff_supplier_documents')">
                <div class="mt-1">
                  <b-button
                    v-if="data.item.image_url"
                    size="sm"
                    variant="outline-success"
                    class="upload-btn"
                    @click="handleUploadPaymentProof(data.item)"
                  >
                    <feather-icon icon="UploadIcon" size="12" class="mr-50" />
                    未上傳
                  </b-button>
                  <b-button
                    v-else
                    size="sm"
                    variant="outline-secondary"
                    class="upload-btn"
                    disabled
                    v-b-tooltip.hover
                    title="請先上傳帳單"
                  >
                    <feather-icon icon="LockIcon" size="12" class="mr-50" />
                    未上傳
                  </b-button>
                </div>
              
              </template>
            </div>
          </template>

          <!-- 付款收據預覽 -->
          <template #cell(payment_receipt_preview)="data">
            <div class="text-center preview-column">
              
              <template
                v-if="
                  data.item.payment_receipt_path ||
                  data.item.payment_receipt_url
                "
              >
              <div class="previewWrapper">
                <template
                  v-if="
                    (
                      data.item.payment_receipt_url ||
                      data.item.payment_receipt_path ||
                      ''
                    ).indexOf('.pdf') > -1
                  "
                >
                  <embed
                    class="pdf"
                    style="max-width: 100px; max-height: 100px"
                    :src="getPaymentReceiptImageUrl(data.item)"
                    type="application/pdf"
                  />
                </template>
                <template v-else>
                  <img
                    style="max-width: 80px; max-height: 80px"
                    :src="getPaymentReceiptImageUrl(data.item)"
                    alt="付款收據"
                    class="img-fluid"
                  />
                </template>
                </div>
                <div>
                  <a
                    class="color1 text-sm"
                    @click="previewPaymentReceipt(data.item)"
                    >預覽</a
                  >
                    <div>{{ data.item.receipt_number }}</div>
                </div>
                <!-- 編輯付款收據按鈕 -->
                <div class="mt-2">
                  <b-button
                    v-if="ability.can('edit_payment_receipt', 'staff_supplier_documents')"
                    size="sm"
                    variant="outline-warning"
                    @click="handleUploadPaymentReceipt(data.item)"
                  >
                    <feather-icon icon="EditIcon" size="14" />
                    編輯
                  </b-button>
                </div>
                <!-- 刪除付款收據按鈕 -->
                <div class="mt-2">
                  <b-button
                    v-if="ability.can('delete_payment_receipt', 'staff_supplier_documents')"
                    size="sm"
                    variant="outline-danger"
                    @click="deleteRecord(data.item.id, 'deleteSupplierPaymentReceipt')"
                  >
                    <feather-icon icon="TrashIcon" size="14" />
                    刪除付款收據紀錄
                  </b-button>
                </div>
              </template>
              <template v-else-if="ability.can('upload_payment_receipt', 'staff_supplier_documents')">
                <div class="mt-1">
                  <b-button
                    v-if="data.item.image_url && hasPaymentProof(data.item)"
                    size="sm"
                    variant="outline-warning"
                    class="upload-btn"
                    @click="handleUploadPaymentReceipt(data.item)"
                  >
                    <feather-icon icon="UploadIcon" size="12" class="mr-50" />
                    未上傳
                  </b-button>
                  <b-button
                    v-else
                    size="sm"
                    variant="outline-secondary"
                    class="upload-btn"
                    disabled
                    v-b-tooltip.hover
                    :title="!data.item.image_url ? '請先上傳帳單' : '請先上傳付款憑證'"
                  >
                    <feather-icon icon="LockIcon" size="12" class="mr-50" />
                    未上傳
                  </b-button>
                </div>
              
              </template>
            </div>
          </template>

          <!-- 日常開支 -->
          <template #cell(is_daily_expense)="data">
            <b-badge :variant="data.item.is_daily_expense ? 'success' : 'danger'">
              {{ data.item.is_daily_expense ? '日常開支' : '成本開支' }}
            </b-badge>
          </template>

          <!-- 詳情 -->
          <template #cell(show_details)="row">
            <b-button
              size="sm"
              @click="row.toggleDetails()"
              class="mr-2"
              variant="info"
            >
              {{ row.detailsShowing ? "隱藏" : "顯示" }}
            </b-button>
          </template>

          <template #cell(is_approved)="data">
            <!-- 自動埋數邏輯：有付款憑證時自動標記為已埋數 -->
            <b-badge :variant="getApprovalStatus(data.item).variant">
              {{ getApprovalStatus(data.item).text }}
            </b-badge>
          </template>

          <template #cell(remark)="data">
            {{ data.item.remark || '-' }}
          </template>

          <template #cell(approve_user_name_cn)="data">
            {{ data.item.approve_user ? data.item.approve_user.name_cn : '-' }}
          </template>

          <template #cell(bill_date)="data">
            {{ data.item.bill_date ? getDate(data.item.bill_date) : '-' }}
          </template>

          <template #cell(bill_total_amount)="data">
            <span class="text-primary font-weight-bold">
              ${{ Number(data.item.bill_total_amount || 0).toFixed(2) }}
            </span>
          </template>

          <template #cell(created_at)="data">
            {{ getDateTime(data.item.created_at) }}
          </template>

          <template #cell(actions)="data">
            <b-dropdown 
              class="action-trigger-btn"
              :right="$store.state.appConfig.isRTL"
            >
              <template #button-content>
                <feather-icon
                  icon="EyeIcon"
                  size="16"
                  class="align-middle text-body"
                />
              </template>

              <!-- <b-dropdown-item
                v-if="ability.can('view_detail', 'staff_supplier_documents')"
                @click="handleViewDetail(data.item.id)"
              >
                <feather-icon icon="EyeIcon" />
                <span class="align-middle ml-50">查看詳情</span>
              </b-dropdown-item> -->

              <b-dropdown-item
                v-if="ability.can('view_supplier', 'staff_supplier_documents') && data.item.supplier && data.item.supplier.id"
                :to="{
                  name: 'staff-supplier-view',
                  params: { id: data.item.supplier.id },
                }"
              >
                <feather-icon icon="UserIcon" />
                <span class="align-middle ml-50">查看供應商</span>
              </b-dropdown-item>

              <!-- <b-dropdown-item
                v-if="ability.can('approve', 'staff_supplier_documents')"
                @click="handleApproval(data.item)"
              >
                <feather-icon icon="CheckIcon" />
                <span class="align-middle ml-50">埋數</span>
              </b-dropdown-item> -->
               <b-dropdown-item
                  v-if="data.item.image_url && ability.can('print', 'staff_supplier_documents')"
                  @click="handlePrintBillDetail(data.item)"
                >
                  <feather-icon icon="PrinterIcon" />
                  <span class="align-middle ml-50">帳單明細列印</span>
                </b-dropdown-item>

              <b-dropdown-item
                v-if="ability.can('update_document', 'staff_supplier_documents')"
                @click="handleModelDocument(data.item)"
              >
                <feather-icon icon="EditIcon" />
                <span class="align-middle ml-50">編輯供應商帳單</span>
              </b-dropdown-item>



              <b-dropdown-item
                v-if="ability.can('delete_document', 'staff_supplier_documents')"
                @click="removeDocument(data.item.id)"
              >
                <feather-icon icon="Trash2Icon" />
                <span class="align-middle ml-50">刪除供應商帳單記錄</span>
              </b-dropdown-item>
            </b-dropdown>
          </template>

          <template #row-details="row">
            <div class="details-container p-2 bg-light border-left border-info">
              <!-- 帳單詳情 -->
              <div class="bill-details mb-4">
                <div class="detail-section">
                  <div class="detail-header d-flex align-items-center mb-3">
                    <div class="detail-icon bg-info text-white rounded-circle d-flex align-items-center justify-content-center mr-3" style="width: 32px; height: 32px;">
                      <feather-icon icon="FileTextIcon" size="16" />
                    </div>
                    <h6 class="mb-0 text-info font-weight-bold">帳單詳情</h6>
                  </div>
                  <div class="detail-content bg-white rounded p-3 shadow-sm">
                    <div v-if="row.item.items && row.item.items.length > 0">
                      <div
                        class="bill-item border-bottom pb-3 mb-3"
                        v-for="(item, index) in row.item.items"
                        :key="`bill_item_${index}`"
                      >
                        <b-row>
                          <b-col cols="12" >
                            <div class="detail-row d-flex mb-2">
                              <span class="detail-label text-muted">帳單編號：</span>
                              <span class="detail-value ml-2 font-weight-medium">{{ item.bill_number == 'null' ? '-' : item.bill_number || '-' }}</span>
                            </div>

                            <!-- 根據開支類型顯示不同的欄位 -->
                            <!-- 日常開支：顯示開支日期 -->
                            <div v-if="row.item.is_daily_expense == 1 || row.item.is_daily_expense === true || row.item.is_daily_expense === '1'" class="detail-row d-flex mb-2">
                              <span class="detail-label text-muted">開支日期：</span>
                              <span class="detail-value ml-2 font-weight-medium">
                                {{ item.daily_expense_date ? getDate(item.daily_expense_date) : '-' }}
                              </span>
                            </div>

                            <!-- 成本開支：顯示發票編號 -->
                            <div v-else class="detail-row d-flex mb-2">
                              <span class="detail-label text-muted">發票編號：</span>
                              <span class="detail-value ml-2 font-weight-medium">
                                <template v-if="item.invoice_id && getInvoiceNumber(item.invoice_id)">
                                  <router-link
                                    :to="{ name: 'invoice-edit', params: { id: item.invoice_id } }"
                                    class="text-primary text-decoration-none"
                                    target="_blank"
                                  >
                                    {{ getInvoiceNumber(item.invoice_id) }}
                                    <!-- <feather-icon icon="ExternalLinkIcon" size="14" class="ml-1" /> -->
                                  </router-link>
                                </template>
                                <template v-else>
                                  -
                                </template>
                              </span>
                            </div>

                            <div class="detail-row d-flex mb-2">
                              <span class="detail-label text-muted">帳單備註：</span>
                              <span class="detail-value ml-2 font-weight-medium">{{ item.title == 'null' ? '-' : item.title || '-' }}</span>
                            </div>
                            <div class="detail-row d-flex mb-2">
                              <span class="detail-label text-muted">金額：</span>
                              <span class="detail-value ml-2 text-success font-weight-bold">
                                ${{ Number(item.amount || 0).toFixed(2) }}
                              </span>
                            </div>
                          </b-col>
                        </b-row>
                      </div>
                    </div>
                    <div v-else class="text-center text-muted py-4">
                      <feather-icon icon="InfoIcon" size="24" class="mb-2 text-muted" />
                      <p class="mb-0">此帳單沒有詳細資訊</p>
                    </div>
                  </div>
                </div>
              </div>

              <!-- 付款憑證詳情 -->
              <div class="payment-proof-details mb-4">
                <div class="detail-section">
                  <div class="detail-header d-flex align-items-center mb-3">
                    <div class="detail-icon bg-success text-white rounded-circle d-flex align-items-center justify-content-center mr-3" style="width: 32px; height: 32px;">
                      <feather-icon icon="CreditCardIcon" size="16" />
                    </div>
                    <h6 class="mb-0 text-success font-weight-bold">付款憑證詳情</h6>
                  </div>
                  <div class="detail-content bg-white rounded p-3 shadow-sm">
                    <div v-if="hasPaymentProof(row.item)">
                      <b-row>
                        <b-col cols="12" >
                          <div class="detail-row d-flex mb-3">
                            <span class="detail-label text-muted">付款憑證編號：</span>
                            <span class="detail-value ml-2 text-success font-weight-medium">{{ row.item.payment_proof_number || '-' }}</span>
                          </div>
                          <div class="detail-row d-flex mb-3">
                            <span class="detail-label text-muted">支付日期：</span>
                            <span class="detail-value ml-2">{{
                              row.item.payment_date
                                ? getDate(row.item.payment_date)
                                : "-"
                            }}</span>
                          </div>
                          <div class="detail-row d-flex mb-3">
                            <span class="detail-label text-muted">支付金額：</span>
                            <span class="detail-value ml-2 text-success font-weight-bold">
                              ${{
                                row.item.payment_amount
                                  ? Number(row.item.payment_amount).toFixed(2)
                                  : Number(row.item.bill_total_amount || 0).toFixed(2)
                              }}
                            </span>
                          </div>
                        </b-col>
                        <b-col cols="12" >
                          <div class="detail-row d-flex mb-3">
                            <span class="detail-label text-muted">支付方式：</span>
                            <span class="detail-value ml-2">{{
                              row.item.payment_method_id
                                ? getPaymentMethodName(row.item.payment_method_id, row.item.check_number)
                                : "-"
                            }}</span>
                            
                          </div>
                        </b-col>
                      </b-row>
                    </div>
                    <div v-else class="text-center text-muted py-4">
                      <feather-icon icon="InfoIcon" size="24" class="mb-2 text-muted" />
                      <p class="mb-0">此記錄沒有付款憑證資訊</p>
                    </div>
                  </div>
                </div>
              </div>

              <!-- 付款收據詳情 -->
              <div class="payment-receipt-details">
                <div class="detail-section">
                  <div class="detail-header d-flex align-items-center mb-3">
                    <div class="detail-icon bg-warning text-white rounded-circle d-flex align-items-center justify-content-center mr-3" style="width: 32px; height: 32px;">
                      <feather-icon icon="BookIcon" size="16" />
                    </div>
                    <h6 class="mb-0 text-warning font-weight-bold">付款收據詳情</h6>
                  </div>
                  <div class="detail-content bg-white rounded p-3 shadow-sm">
                    <div v-if="row.item.payment_receipt_url">
                      <b-row>
                        <b-col cols="12">
                          <div class="detail-row d-flex mb-3">
                            <span class="detail-label text-muted">收據編號：</span>
                            <span class="detail-value ml-2 text-success font-weight-medium">{{ row.item.receipt_number || '-' }}</span>
                          </div>
                          <div class="detail-row d-flex mb-3">
                            <span class="detail-label text-muted">收據備註：</span>
                            <span class="detail-value ml-2">{{ row.item.payment_receipt_remark == 'null' ?  '-' : row.item.payment_receipt_remark || '-' }}</span>
                          </div>
                        </b-col>
                        <b-col cols="12">
                          <div class="detail-row d-flex mb-3">
                            <span class="detail-label text-muted">收據日期：</span>
                            <span class="detail-value ml-2">{{
                              row.item.receipt_date
                                ? getDate(row.item.receipt_date)
                                : "-"
                            }}</span>
                          </div>
                          <!-- <div class="detail-row d-flex mb-3">
                            <span class="detail-label text-muted">上傳日期：</span>
                            <span class="detail-value ml-2">{{
                              row.item.created_at
                                ? getDateTime(row.item.created_at)
                                : "-"
                            }}</span>
                          </div> -->
                        </b-col>
                      </b-row>
                    </div>
                    <div v-else class="text-center text-muted py-4">
                      <feather-icon icon="InfoIcon" size="24" class="mb-2 text-muted" />
                      <p class="mb-0">此記錄沒有付款收據資訊</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </template>
        </b-table>
        
        <div class="mt-2 d-flex justify-content-between align-items-center">
          <!-- <span>總額：${{ totalAmount }}</span> -->
          <b-pagination
            v-model="currentPage"
            :total-rows="totalSupplierDocuments"
            :per-page="perPage"
            align="right"
            size="sm"
            class="my-0"
          />
        </div>
      </b-card-body>
    </b-card>

    <!-- Modals -->
    <modal-image-viewer
      :image-list="previewImage"
      :selected_file="selected_file"
    />

    <modal-upload-bill
      apiUrl="/suppliers/documents"
      :document-data="documentData"
      :invoice-options="invoiceOptions"
      :user_id="selectedSupplierId"
      :show-supplier-select="isUploadMode"
      :supplier-options="supplierOptions"
      @refetch-data="refetchData"
    />

    <modal-upload-payment-proof
      :bill-data="selectedBillData"
      :payment-proof-data="selectedPaymentProofData"
      :payment-method-options="paymentMethodOptions"
      :is-edit="isEditPaymentProof"
      @refetch-data="refetchData"
    />

    <modal-upload-payment-receipt
      :bill-data="selectedBillData"
      :payment-proof-data="selectedPaymentProofData"
      :payment-receipt-data="selectedPaymentReceiptData"
      :is-edit="isEditPaymentReceipt"
      @refetch-data="refetchData"
    />

    <modal-approval
      :approve-data="approveData"
      @refetch-data="refetchData"
    />

    <supplier-document-detail
      :document-detail="documentDetailData"
      :invoice-options="invoiceOptions"
      @edit="handleModelDocument"
      @delete="removeDocument"
    />
  </div>
</template>

<script>
import {
  BCard,
  BCardBody,
  BTable,
  BFormInput,
  BButton,
  BDropdown,
  BDropdownItem,
  BBadge,
  BPagination,
  BRow,
  BCol,
  VBTooltip,
} from "bootstrap-vue";
import { ref, onUnmounted, onMounted, watch } from "@vue/composition-api";
import vSelect from "vue-select";
import store from "@/store";
import { formatCurrency } from "@core/utils/filter";
import supplierStoreModule from "../supplierStoreModule";
import ability from "@/libs/acl/ability";
import ModalImageViewer from "@/layouts/components/file/ModalImageViewer.vue";
import ModalUploadBill from "../modal/ModalUploadBill.vue";
import ModalUploadPaymentProof from "../modal/ModalUploadPaymentProof.vue";
import ModalUploadPaymentReceipt from "../modal/ModalUploadPaymentReceipt.vue";
import ModalApproval from "../modal/ModalApproval";
import SupplierDocumentDetail from "../modal/SupplierDocumentDetail.vue";
import ModalSupplierDocumentFilter from "../modal/ModalSupplierDocumentFilter.vue";

export default {
  components: {
    BCard,
    BCardBody,
    BTable,
    BFormInput,
    BButton,
    BDropdown,
    BDropdownItem,
    BBadge,
    BPagination,
    BRow,
    BCol,
    vSelect,
    ModalImageViewer,
    ModalUploadBill,
    ModalUploadPaymentProof,
    ModalUploadPaymentReceipt,
    ModalApproval,
    SupplierDocumentDetail,
    ModalSupplierDocumentFilter,
  },
  directives: {
    'b-tooltip': VBTooltip,
  },
  data() {
    return {
      ability,
      previewImage: null,
      selected_file: null,
      approveData: null,
      documentData: {},
      selectedSupplierId: 0,
      documentDetailData: {},
      isUploadMode: false,
      // 付款憑證和收據相關資料
      selectedBillData: {},
      selectedPaymentProofData: {},
      selectedPaymentReceiptData: {},
      isEditPaymentProof: false,
      isEditPaymentReceipt: false,
      // 詳情顯示狀態
      detailsShowing: {},
    };
  },
  methods: {
    // 自動埋數邏輯：有付款憑證時自動標記為已埋數
    getApprovalStatus(item) {
      const hasPaymentProofData = this.hasPaymentProof(item);
      if (hasPaymentProofData) {
        return {
          variant: 'success',
          text: '已埋數'
        };
      } else {
        return {
          variant: 'warning',
          text: '未埋數'
        };
      }
    },
    // 註釋掉原本的手動埋數功能
    // handleApproval(item) {
    //   this.approveData = item;
    //   this.$bvModal.show("modal-approval");
    // },
    handleModelDocument(item) {
      if (item) {
        this.documentData = item;
        this.selectedSupplierId = item.supplier ? item.supplier.id : 0;
        this.isUploadMode = false;
      } else {
        this.documentData = {
          id: 0,
          items: [{ id: 0, invoice_id: null, amount: 0, title: "", daily_expense_date: null, file: null }]
        };
        this.isUploadMode = true; // 新增模式，顯示供應商選擇
        this.selectedSupplierId = 0;
      }
      this.$bvModal.show("modal-upload-bill");
    },
    handlePrintBillDetail(item) {
      // 跳轉到帳單明細列印頁面
      this.$router.push({
        name: 'supplier-bill-detail-print',
        params: { id: item.id }
      });
    },
    previewImageSet(item, index) {
      if (item && item.length > 0) {
        this.previewImage = item.map((ele) => {
          return {
            id: ele.id,
            src: ele.image_url,
            name: ele.name,
            type: ele.image_path.indexOf("pdf") > -1 ? "application/pdf" : "image/jpeg",
          };
        });
      } else {
        this.previewImage = [];
      }
      this.selected_file = index;

      setTimeout(() => {
        this.$bvModal.show(`modal-image-viewer`);
      });
    },
    removeDocument(id) {
      this.$swal({
        title: "你確定嗎?",
        text: "您的決定是最終決定，您將無法取回這記錄。",
        showCancelButton: true,
        confirmButtonText: "刪除",
        cancelButtonText: "取消",
        customClass: {
          confirmButton: "btn btn-primary",
          cancelButton: "btn btn-outline-danger ml-1",
        },
        buttonsStyling: false,
      }).then((result) => {
        if (result.value) {
          this.$store
            .dispatch("supplier/deleteSupplierDocument", { id })
            .then((response) => {
              this.$swal({
                text: response.data.message,
                icon: "success",
                customClass: {
                  confirmButton: "btn btn-primary",
                },
                showClass: {
                  popup: "animate__animated animate__bounceIn",
                },
                buttonsStyling: false,
              });
              this.refetchData();
            })
            .catch((error) => {
              this.$swal({
                text: error.response.data.message,
                icon: "error",
                customClass: {
                  confirmButton: "btn btn-primary",
                },
                showClass: {
                  popup: "animate__animated animate__bounceIn",
                },
                buttonsStyling: false,
              });
            });
        }
      });
    },
    getDateTime(dateString) {
      if (!dateString) return '';
      const date = new Date(dateString);
      return date.toLocaleString('zh-TW', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit'
      });
    },
    handleViewDetail(id) {
      this.$store
        .dispatch("supplier/fetchSupplierDocumentDetail", { id })
        .then((response) => {
          this.documentDetailData = response.data.document;
          this.$bvModal.show("modal-supplier-document-detail");
        })
        .catch((error) => {
          this.$swal({
            text: error.response?.data?.message || "獲取帳單詳情失敗",
            icon: "error",
            customClass: {
              confirmButton: "btn btn-primary",
            },
            showClass: {
              popup: "animate__animated animate__bounceIn",
            },
            buttonsStyling: false,
          });
        });
    },
    handleUploadPaymentProof(item) {
      this.selectedBillData = item;
      // 判斷是否為編輯模式（已有付款憑證）
      this.isEditPaymentProof = this.hasPaymentProof(item);

      // 設置付款憑證數據，包含現有的付款憑證資訊
      this.selectedPaymentProofData = {
        id: item.id,
        payment_date: item.payment_date,
        payment_amount: item.payment_amount || item.bill_total_amount,
        payment_method_id: item.payment_method_id,
        check_number: item.check_number,
        payment_proof_path: item.payment_proof_path,
        payment_proof_url: item.payment_proof_url,
        payment_proof_number: item.payment_proof_number,
        ...item.payment_proof
      };
      this.$bvModal.show("modal-upload-payment-proof");
    },
    handleUploadPaymentReceipt(item) {
      this.selectedBillData = item;
      // 判斷是否為編輯模式（已有付款收據）
      this.isEditPaymentReceipt = !!(item.payment_receipt_path || item.payment_receipt_url);

      // 設置付款憑證數據
      this.selectedPaymentProofData = {
        id: item.id,
        payment_date: item.payment_date,
        payment_amount: item.payment_amount || item.bill_total_amount,
        payment_method_id: item.payment_method_id,
        check_number: item.check_number,
        payment_proof_path: item.payment_proof_path,
        payment_proof_number: item.payment_proof_number,
        payment_proof_url: item.payment_proof_url,
        ...item.payment_proof
      };
      // 設置付款收據數據
      this.selectedPaymentReceiptData = {
        id: item.id,
        receipt_date: item.receipt_date,
        receipt_number: item.receipt_number,
        remark: item.payment_receipt_remark,
        payment_receipt_path: item.payment_receipt_path,
        payment_receipt_url: item.payment_receipt_url,
        ...item.payment_receipt
      };
      this.$bvModal.show("modal-upload-payment-receipt");
    },
    // 圖片 URL 處理方法 - 修復生產環境圖片顯示問題
    getFullImageUrl(url) {
      if (!url) return "";

      // 如果已經是完整 URL，直接返回
      if (url.startsWith("http://") || url.startsWith("https://")) {
        return url;
      }

      // 構建完整 URL，確保在生產環境正確顯示
      const baseUrl = process.env.VUE_APP_API_BASE_URL;
      // 確保 URL 路徑正確拼接
      const fullUrl = url.startsWith('/') ? `${baseUrl}${url}` : `${baseUrl}/${url}`;
      return fullUrl;
    },
    // 檢查是否有付款憑證（支援新版多筆和舊版單一）
    hasPaymentProof(item) {
      // 檢查新版多筆付款憑證
      if (item.payment_proofs && item.payment_proofs.length > 0) {
        return true;
      }
      // 檢查舊版單一付款憑證
      return !!(item.payment_proof_path || item.payment_proof_url);
    },

    // 獲取付款憑證編號（支援新版多筆和舊版單一）
    getPaymentProofNumber(item) {
      // 檢查新版多筆付款憑證
      if (item.payment_proofs && item.payment_proofs.length > 0) {
        if (item.payment_proofs.length === 1) {
          return item.payment_proofs[0].payment_proof_number;
        } else {
          // 顯示第一個憑證編號和總數
          const firstNumber = item.payment_proofs[0].payment_proof_number;
          return `${firstNumber} 等 ${item.payment_proofs.length} 筆`;
        }
      }
      // 檢查舊版單一付款憑證
      return item.payment_proof_number || '';
    },

    // 獲取付款憑證檔案類型（支援新版多筆和舊版單一）
    getPaymentProofFileType(item) {
      let fileUrl = '';

      // 檢查新版多筆付款憑證
      if (item.payment_proofs && item.payment_proofs.length > 0) {
        fileUrl = item.payment_proofs[0].payment_proof_url || item.payment_proofs[0].payment_proof_path || '';
      } else {
        // 檢查舊版單一付款憑證
        fileUrl = item.payment_proof_url || item.payment_proof_path || '';
      }

      return fileUrl.toLowerCase().indexOf('.pdf') > -1 ? 'pdf' : 'image';
    },

    // 獲取付款憑證圖片 URL（支援新版多筆和舊版單一）
    getPaymentProofImageUrl(item) {
      // 檢查新版多筆付款憑證
      if (item.payment_proofs && item.payment_proofs.length > 0) {
        const firstProof = item.payment_proofs[0];
        return this.getFullImageUrl(firstProof.payment_proof_url || firstProof.payment_proof_path);
      }
      // 檢查舊版單一付款憑證
      return this.getFullImageUrl(
        item.payment_proof_url || item.payment_proof_path
      );
    },
    // 獲取付款收據圖片 URL
    getPaymentReceiptImageUrl(item) {
      return this.getFullImageUrl(
        item.payment_receipt_url || item.payment_receipt_path
      );
    },
    // 預覽付款憑證（支援新版多筆和舊版單一）
    previewPaymentProof(item) {
      let previewImages = [];

      // 檢查新版多筆付款憑證
      if (item.payment_proofs && item.payment_proofs.length > 0) {
        previewImages = item.payment_proofs.map((proof, index) => ({
          id: proof.id,
          src: proof.payment_proof_url,
          name: `付款憑證 ${index + 1} - ${proof.payment_proof_number}`,
          type: proof.payment_proof_url && proof.payment_proof_url.toLowerCase().indexOf("pdf") > -1
            ? "application/pdf"
            : "image/jpeg",
        }));
      } else {
        // 檢查舊版單一付款憑證
        previewImages = [
          {
            id: item.id,
            src: item.payment_proof_url,
            name: "付款憑證",
            type:
              item.payment_proof_url && item.payment_proof_url.toLowerCase().indexOf("pdf") > -1
                ? "application/pdf"
                : "image/jpeg",
          },
        ];
      }

      this.previewImage = previewImages;
      this.selected_file = 0;
      this.$bvModal.show("modal-image-viewer");
    },
    // 預覽付款收據
    previewPaymentReceipt(item) {
      this.previewImage = [
        {
          id: item.id,
          src: item.payment_receipt_url,
          name: "付款收據",
          type:
            item.payment_receipt_url.indexOf("pdf") > -1
              ? "application/pdf"
              : "image/jpeg",
        },
      ];
      this.selected_file = 0;
      this.$bvModal.show("modal-image-viewer");
    },
    // 日期格式化方法
    getDate(dateString) {
      if (!dateString) return '';
      const date = new Date(dateString);
      return date.toLocaleDateString('zh-TW');
    },
    getDateTime(dateString) {
      if (!dateString) return '';
      const date = new Date(dateString);
      return date.toLocaleString('zh-TW', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit'
      });
    },
    deleteRecord(id, apiKey) {
      // 設定不同的確認訊息
      let confirmText = "您的行動是最終的，您將無法檢索記錄。";
      if (apiKey === 'deleteSupplierBillFiles') {
        confirmText = "您將刪除此帳單的所有檔案，但帳單記錄將保留。";
      } else if (apiKey === 'deleteSupplierPaymentProof') {
        confirmText = "您的行動是最終的，您將無法檢索付款憑證記錄。";
      } else if (apiKey === 'deleteSupplierPaymentReceipt') {
        confirmText = "您的行動是最終的，您將無法檢索付款收據記錄。";
      }

      this.$swal({
        title: "你確定嗎?",
        text: confirmText,
        showCancelButton: true,
        confirmButtonText: "刪除",
        cancelButtonText: "取消",
        customClass: {
          confirmButton: "btn btn-primary",
          cancelButton: "btn btn-outline-danger ml-1",
        },
        buttonsStyling: false,
      }).then((result) => {
        if (result.value) {
          const params = { id: id };

          this.$store
            .dispatch(`supplier/${apiKey}`, params)
            .then((response) => {
              this.$swal({
                text: response.data.message,
                icon: "success",
                customClass: {
                  confirmButton: "btn btn-primary",
                },
                buttonsStyling: false,
              });
              // 刷新頁面
              this.$router.go(0);
            })
            .catch((error) => {
              if (error.response && error.response.data && error.response.data.message) {
                this.$swal({
                  text: error.response.data.message,
                  icon: "error",
                  customClass: {
                    confirmButton: "btn btn-primary",
                  },
                  buttonsStyling: false,
                });
              }
            });
        }
      });
    },
  },
  setup() {
    const supplier_APP_STORE_MODULE_NAME = "supplier";

    if (!store.hasModule(supplier_APP_STORE_MODULE_NAME))
      store.registerModule(supplier_APP_STORE_MODULE_NAME, supplierStoreModule);

    onUnmounted(() => {
      if (store.hasModule(supplier_APP_STORE_MODULE_NAME))
        store.unregisterModule(supplier_APP_STORE_MODULE_NAME);
    });

    const refSupplierDocumentListTable = ref(null);
    const supplierDocuments = ref([])
    // Reactive data
    const totalSupplierDocuments = ref(0);
    const totalAmount = ref(0);
    const approvedAmount = ref(0);
    const pendingAmount = ref(0);
    const currentPage = ref(1);
    const perPage = ref(10);
    const sortBy = ref("id");
    const isSortDirDesc = ref(true);
    const searchQuery = ref("");
    const expenseTypeFilter = ref("all");
    const approvalStatusFilter = ref("all");

    // 新增篩選變數
    const filter_expense_type = ref(null);
    const filter_approval_status = ref(null);
    const filter_supplier_id = ref(null);
    const filter_date_from = ref(null);
    const filter_date_to = ref(null);

    const perPageOptions = [10, 25, 50, 100];
    const expenseTypeOptions = [
      { label: "全部", value: "all" },
      { label: "日常開支", value: "1" },
      { label: "成本開支", value: "0" }
    ];
    const approvalStatusOptions = [
      { label: "全部", value: "all" },
      { label: "已埋數", value: "1" },
      { label: "未埋數", value: "0" }
    ];

    // Table columns - 與 supplierView.vue 保持一致
    const documentTableColumns = ref([
      { key: "supplier", label: "供應商" },
      { key: "bill_preview", label: "帳單" },
      { key: "payment_proof_preview", label: "付款憑證" },
      // { key: "payment_proof_number", label: "付款憑證編號" },
      { key: "payment_receipt_preview", label: "付款收據" },
      // { key: "receipt_number", label: "付款收據編號" },
      { key: "bill_date", label: "帳單日期" },
      { key: "bill_total_amount", label: "帳單總金額", formatter: formatCurrency },
      { key: "is_daily_expense", label: "日常開支" },
      { key: "show_details", label: "詳情" },
      { key: "actions", label: "操作" },
      { key: "is_approved", label: "埋數" },
      // { key: "remark", label: "埋數備註" },
      { key: "approve_user_name_cn", label: "埋數人員" },
    ]);

    // Fetch data function
    const fetchSupplierDocuments = (ctx, callback) => {
        console.log("fetchSupplierDocuments called with ctx:", ctx);
        store
          .dispatch("supplier/fetchAllSupplierDocuments", {
            q: searchQuery.value,
            perPage: perPage.value,
            page: currentPage.value,
            sortBy: sortBy.value,
            sortDesc: isSortDirDesc.value,
            is_daily_expense: filter_expense_type.value || (expenseTypeFilter.value === "all" ? null : expenseTypeFilter.value),
            approval_status: filter_approval_status.value || (approvalStatusFilter.value === "all" ? null : approvalStatusFilter.value),
            supplier_id: filter_supplier_id.value,
            date_from: filter_date_from.value,
            date_to: filter_date_to.value,
          })
          .then((response) => {
            console.log("API response:", response.data);
            const { documents, total, total_amount, approved_amount, pending_amount } = response.data;
            console.log("Documents:", documents, "Total:", total);
            callback(documents || []);
            supplierDocuments.value = documents || []
            totalSupplierDocuments.value = total || 0;
            totalAmount.value = total_amount || 0;
            approvedAmount.value = approved_amount || 0;
            pendingAmount.value = pending_amount || 0;
          })
          .catch((error) => {
            console.error("error when fetching supplier documents", error);
            console.error("error response:", error.response);
            if (error.response && error.response.data && error.response.data.message) {
              console.error("API error message:", error.response.data.message);
            }
            callback([]);
          });
    };

    const refetchData = () => {
       refSupplierDocumentListTable.value.refresh();
    };


    const invoiceOptions = ref([]);
    const supplierOptions = ref([]);
    const paymentMethodOptions = ref([]);

    const refetchOption = () => {
      console.log("Fetching options...");
      store
        .dispatch("app/fetchOptionList", {
          invoices: true,
          suppliers: true,
          suppliers_all: true, // 包含所有供應商（包括未啟用的）
          receive_methods: true
        })
        .then((response) => {
          console.log("Options fetched:", response.data);
          invoiceOptions.value = response.data.invoices;
          // 使用 suppliers_all 如果存在，否則使用 suppliers
          supplierOptions.value = response.data.suppliers_all || response.data.suppliers;
          paymentMethodOptions.value = response.data.receive_methods.sort ((a, b) => a.sort_order - b.sort_order);
        })
        .catch((error) => {
          console.error("Error fetching options:", error);
        });
    };

    const getInvoiceNumber = (invoice_id) => {
      const invoice = invoiceOptions.value.find(invoice => invoice.id === invoice_id);
      return invoice ? invoice.invoice_number : '';
    };

    const handleExport = () => {
      const exportParams = {
        q: searchQuery.value,
        is_daily_expense: filter_expense_type.value || (expenseTypeFilter.value === "all" ? null : expenseTypeFilter.value),
        approval_status: filter_approval_status.value || (approvalStatusFilter.value === "all" ? null : approvalStatusFilter.value),
        supplier_id: filter_supplier_id.value,
        date_from: filter_date_from.value,
        date_to: filter_date_to.value,
      };

      store
        .dispatch("supplier/exportSupplierDocuments", exportParams)
        .then((response) => {
          // 創建下載連結
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', 'supplier_documents.xlsx');
          document.body.appendChild(link);
          link.click();
          link.remove();
          window.URL.revokeObjectURL(url);
        })
        .catch((error) => {
          console.error("匯出失敗:", error);
        });
    };

    // Watch for changes
    watch([currentPage, perPage, sortBy, isSortDirDesc, searchQuery, expenseTypeFilter, approvalStatusFilter, filter_expense_type, filter_approval_status, filter_supplier_id, filter_date_from, filter_date_to], () => {
      refetchData()
    });

    onMounted(() => {
      console.log("Component mounted, fetching options...");
      refetchOption();
    });

    function getPaymentMethodName(paymentMethodId, checkNumber = null) {
      if (!paymentMethodId || !paymentMethodOptions.value || !paymentMethodOptions.value.length) {
        return '-';
      }
      const method = paymentMethodOptions.value.find(m => m.id === paymentMethodId);
      if (!method) return '-';

      // 如果是支票支付方式（payment_method_id == 1）且有支票號碼
      if (paymentMethodId == 1 && checkNumber) {
        return `${method.name} - ${checkNumber}`;
      }

      return method.name;
    }

    return {
      refSupplierDocumentListTable,
      totalSupplierDocuments,
      totalAmount,
      approvedAmount,
      pendingAmount,
      currentPage,
      perPage,
      perPageOptions,
      sortBy,
      isSortDirDesc,
      searchQuery,
      expenseTypeFilter,
      expenseTypeOptions,
      approvalStatusFilter,
      approvalStatusOptions,
      filter_expense_type,
      filter_approval_status,
      filter_supplier_id,
      filter_date_from,
      filter_date_to,
      documentTableColumns,
      invoiceOptions,
      supplierOptions,
      paymentMethodOptions,
      fetchSupplierDocuments,
      supplierDocuments,
      refetchData,
      getInvoiceNumber,
      handleExport,
      getPaymentMethodName,
    };
  },
};
</script>

<style lang="scss" scoped>
@import "@core/scss/vue/libs/vue-select.scss";

.supplier-documents-list-wrapper {
  .search-form {
    max-width: 200px;
  }

  .expense-type-selector,
  .approval-status-selector {
    min-width: 120px;
  }
}

// 確保未上傳 badge 顯示正確
.badge.badge-light {
  background-color: #f8f9fa !important;
  color: #6c757d !important;
  border: 1px solid #dee2e6 !important;
}

// 多筆付款憑證的視覺效果
.previewWrapper {
  .payment-proof-shadow {
    box-shadow: 0 2px 4px rgba(0,0,0,0.1);
  }

  .position-absolute.badge {
    box-shadow: 0 1px 3px rgba(0,0,0,0.3);
  }
}

// 付款憑證預覽圖片的懸停效果
.previewWrapper img, .previewWrapper embed {
  transition: transform 0.2s ease;
  cursor: pointer;

  &:hover {
    transform: scale(1.05);
  }
}

// 上傳按鈕樣式
.upload-btn {
  font-size: 0.75rem;
  padding: 0.25rem 0.5rem;
  border-radius: 0.25rem;
  transition: all 0.2s ease-in-out;

  &:hover:not(:disabled) {
    transform: translateY(-1px);
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  }

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }

  .feather {
    vertical-align: middle;
  }
}

.amount-stats-container {
  display: flex;
  gap: 1rem;

  .amount-stat-card {
    flex: 1;
    min-width: 0; // 防止 flex 項目溢出
  }

  // 響應式設計：在小屏幕上垂直排列
  @media (max-width: 768px) {
    flex-direction: column;
    gap: 0.5rem;
  }
}

// 詳情區域樣式
.details-container {
  background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
  border-radius: 12px;
  margin: 15px 0;
  border-left: 4px solid #17a2b8;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
  display: flex;
  gap: 1.5rem;
}

.detail-section {
  margin-bottom: 1.5rem;
}

.detail-header {
  margin-bottom: 1rem;
}

.detail-icon {
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
  transition: transform 0.2s ease;

  &:hover {
    transform: scale(1.05);
  }
}

.detail-content {
  border: 1px solid #e9ecef;
  transition: box-shadow 0.3s ease;

  &:hover {
    box-shadow: 0 6px 20px rgba(0, 0, 0, 0.08);
  }
}

.detail-row {
  align-items: flex-start;
  min-height: 24px;
}

.detail-label {
  min-width: 100px;
  font-size: 0.875rem;
  font-weight: 500;
  flex-shrink: 0;
}

.detail-value {
  font-size: 0.875rem;
  word-break: break-word;
  flex: 1;
}

.bill-item:last-child {
  border-bottom: none !important;
  margin-bottom: 0 !important;
  padding-bottom: 0 !important;
}

.preview-column {
  min-width: 120px;
  .btn-sm {
    padding: 0.25rem 0.5rem;
    font-size: 0.75rem;
    border-radius: 0.25rem;

    .feather {
      margin-right: 0.25rem;
    }
  }

  .btn-outline-primary {
    border-color: #007bff;
    color: #007bff;

    &:hover {
      background-color: #007bff;
      color: white;
    }
  }

  .btn-outline-success {
    border-color: #28a745;
    color: #28a745;

    &:hover {
      background-color: #28a745;
      color: white;
    }
  }

  .btn-outline-warning {
    border-color: #ffc107;
    color: #ffc107;

    &:hover {
      background-color: #ffc107;
      color: white;
    }
  }
}

// 響應式設計
@media (max-width: 768px) {
  .details-container {
    padding: 1rem;
  }

  .detail-content {
    padding: 1rem;
  }

  .detail-row {
    flex-direction: column;
    margin-bottom: 0.75rem;
  }

  .detail-label {
    min-width: auto;
    margin-bottom: 0.25rem;
  }

  .detail-value {
    margin-left: 0 !important;
  }
}

.previewWrapper{
  display:flex;
  align-items: center;
  justify-content: center;
  width: 120px;
  height: 80px;
  overflow: hidden;
  margin:auto;
}
</style>
